import React, {useEffect} from "react";
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import {observer} from "mobx-react";

type AddToWishListV2Props = {
    productCard: ShowableProductCard
}

const AddToWishListV2 = observer((props: AddToWishListV2Props) => {

    const { currentProductConfig } =  props.productCard;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }

    const uniqueKey = currentProductConfig.getUniqueId();

    useEffect(() => {
        window?.widgets?.addToWishListV1?.checkSelected();
    }, [uniqueKey]);

    return (
        <a className="link-with-icon-v1 add-to-wishlist-v1 link-with-icon-v1_text-color-type-main link-with-icon-v1_decoration-type-none"
           key={uniqueKey}
           href="#" add-to-wishlist-v1=""
           data-add-to-wishlist-v1-is-in-wishlist="0"
           data-add-to-wishlist-v1-product-type-id={currentProductConfig.productTypeId}
           data-add-to-wishlist-v1-id={currentProductConfig.id}
           data-add-to-wishlist-v1-virtual-modifier-id={currentProductConfig.virtualModifierId ?? ""}
        >
            <svg className="icon-v1 link-with-icon-v1__icon" width="20" height="20">
                <use xlinkHref="/build/sprite.svg#heart-icon-transparent">
                </use>
            </svg>
            <div className="link-with-icon-v1__label">В избранное</div>
        </a>
    )
});

export { AddToWishListV2 };